/**
 * HomeScreen Skeleton Component
 * ITEM 2: Lightweight skeleton/shimmer for Home screen loading state
 * Matches the structure of HomeScreen for smooth loading experience
 */

export function HomeScreenSkeleton() {
  return (
    <div
      className="min-h-[100dvh] bg-gradient-to-b from-[#f9f3f0] from-[41.312%] to-white relative"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'calc(3.5rem + 80px + env(safe-area-inset-bottom))',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Header Skeleton */}
      <div className="mx-auto max-w-md px-4 pt-1 pb-1.5">
        <div className="flex items-center justify-between">
          <div className="w-12"></div>
          <div className="h-6 w-32 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-12 w-12 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="mx-auto max-w-md px-4 space-y-3">
        {/* Calorie Balance Card Skeleton */}
        <div className="relative overflow-hidden rounded-[20px] bg-white/80 border border-[rgba(225,225,225,0.4)] px-3 py-2.5 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.02)]">
          <div className="flex items-center justify-between mb-2 px-1">
            <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-10 w-10 bg-gray-200 rounded-3xl animate-pulse"></div>
          </div>
          <div className="h-10 w-48 bg-gray-200 rounded animate-pulse"></div>
        </div>

        {/* Metric tiles skeleton — protein / weight / hydration */}
        <div className="grid grid-cols-3 gap-2">
          {/* Weight Card Skeleton */}
          <div className="relative rounded-2xl bg-white/80 border border-[rgba(225,225,225,0.4)] p-3 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.02)]">
            <div className="flex flex-col items-center gap-3">
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              <div className="flex flex-col items-center gap-1">
                <div className="h-3 w-12 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-6 w-16 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>

          {/* Protein Card Skeleton */}
          <div className="relative rounded-2xl bg-white/80 border border-[rgba(225,225,225,0.4)] p-3 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.02)]">
            <div className="flex flex-col items-center gap-3">
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              <div className="flex flex-col items-center">
                <div className="h-3 w-14 bg-gray-200 rounded animate-pulse mb-1"></div>
                <div className="h-6 w-12 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>

          {/* Hydration Card Skeleton */}
          <div className="relative rounded-2xl bg-white/80 border border-[rgba(225,225,225,0.4)] p-3 shadow-[0px_8px_40px_0px_rgba(0,0,0,0.02)]">
            <div className="flex flex-col items-center gap-3">
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              <div className="flex flex-col items-center gap-1">
                <div className="h-3 w-16 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-6 w-12 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons Skeleton */}
        <div className="grid grid-cols-2 gap-2 pt-0.5">
          <div className="h-[52px] rounded-[32px] bg-gray-200 animate-pulse"></div>
          <div className="h-[52px] rounded-[32px] bg-gray-200 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}
